// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3bPUc","selects":"Documents_selects__3C4l4"};